import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Branding */}
          <div>
            <h3 className="font-futura font-black text-2xl mb-4">SINJAVINA SKYRACE</h3>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/sinjavina_skyrace/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:bg-primary hover:border-primary transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="mailto:sinjavinaskyrace@gmail.com"
                className="w-10 h-10 rounded-full border-2 border-white/30 flex items-center justify-center hover:bg-primary hover:border-primary transition-all cursor-pointer"
                aria-label="Email"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-futura font-bold text-base mb-6">{t('common:footer.quickLinks')}</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-gray-400 text-sm hover:text-primary transition-colors cursor-pointer">
                {t('common:nav.home')}
              </Link>
              <Link to="/registration" className="text-gray-400 text-sm hover:text-primary transition-colors cursor-pointer">
                {t('common:nav.registration')}
              </Link>
              <Link to="/regulations" className="text-gray-400 text-sm hover:text-primary transition-colors cursor-pointer">
                {t('common:nav.regulations')}
              </Link>
              <a
                href="mailto:sinjavinaskyrace@gmail.com"
                className="text-gray-400 text-sm hover:text-primary transition-colors cursor-pointer"
              >
                {t('common:footer.contact')}
              </a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-futura font-bold text-base mb-6">{t('common:footer.contact')}</h4>
            <div className="flex flex-col gap-3 text-sm text-gray-400">
              <div className="flex items-start gap-2">
                <i className="ri-mail-line text-primary mt-0.5"></i>
                <a href="mailto:sinjavinaskyrace@gmail.com" className="hover:text-primary transition-colors cursor-pointer">
                  sinjavinaskyrace@gmail.com
                </a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-phone-line text-primary mt-0.5"></i>
                <a href="tel:+38268898636" className="hover:text-primary transition-colors cursor-pointer">
                  +382 68/898-636
                </a>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary mt-0.5"></i>
                <span>Mojkovac, Montenegro</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black/50 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-gray-500">
            <p>{t('common:footer.copyright')}</p>
            <a 
              href="https://www.avaibooksports.com/en/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors cursor-pointer"
            >
              {t('common:footer.poweredBy')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}